import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[ktSelectPanel]' })
export class KtSelectPanelDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
